import Input from "../../../../../common/components/input-service-request/Input";
import { Money } from "../../../../../model/common/money";
import { formatCurrency } from "../../../../../utils";
import { useServiceRequestForm } from "../../context/ServiceRequestFormContext";
import { StepProps } from "../../informations";
import styles from "./steps.module.scss";

const PaymentStep = ({ title, message }: StepProps) => {
    const { form: { watch, setValue } } = useServiceRequestForm();
    const paymentMethod = watch("paymentMethod");
    const amount = watch("amount");

    return (
        <div className={styles.mainStepContent}>
            <div className={styles.headerContainer}>
                <h2 className={styles.headerTitle}>{title}</h2>
                <p className={styles.headerDescription}>{message}</p>
            </div>

            <div className={styles.formContainer}>
                <div className={styles.formFieldContainer}>
                    <span className={styles.formLabel}>Payment Method</span>
                    <div className={styles.tabsContainer} >
                        <button
                            type="button"
                            className={`${styles.tab} ${paymentMethod === "pay_now" ? styles.tabActive : ""}`}
                            onClick={() => setValue("paymentMethod", "pay_now")}
                            disabled={amount == null || amount.amount === 0}
                        >
                            Pay Now
                        </button>
                        <button
                            type="button"
                            className={`${styles.tab} ${paymentMethod === "pay_with_link" ? styles.tabActive : ""}`}
                            onClick={() => setValue("paymentMethod", "pay_with_link")}
                           disabled={amount == null || amount.amount === 0}
                            
                        >
                            Pay with Link
                        </button>
                    </div>
                </div>
                {(amount == null || amount.amount === 0) && (
                    <p className={styles.freeServiceNotice}>
                        This service request is free of charge. No payment is required.
                    </p>
                )}
            </div>
            <hr className={styles.divider} />
            <div className={styles.formContainer}>
                <Input
                    label="Amount"
                    readOnly
                    value={formatCurrency(amount?.amount ?? 0, { currency: amount?.currency })}
                />
            </div>
        </div>
    );
};

export default PaymentStep;
